import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { stepStatus } from 'app-models';
import { updateStepStatus } from 'visa-store';
import { selectFormDirty, ConfirmationModalComponent, MarkCleanFormAction } from 'dirty-check-store';
import { take } from 'rxjs/operators';
import * as i1 from '@ngrx/store';
import * as i2 from 'step-status-update-payload-service';
import * as i3 from '@angular/material/dialog';
import * as i4 from 'ngx-ui-loader';
import * as i6 from 'reference-library';
import * as i7 from '@angular/common';
import * as i8 from 'primeng/overlaypanel';
import * as i9 from 'primeng/api';
import * as i10 from 'primeng/tooltip';
import * as i11 from 'primeng/button';
import * as i12 from 'task-notes-lib';
import { TaskNotesLibModule } from 'task-notes-lib';
import { PrimengLibraryModule } from 'primeng-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';

class StepStatusUpdateComponentLibraryService {
    constructor() {
        this.closeSubject = new Subject();
        this.closeSubject$ = this.closeSubject.asObservable();
        this.nextPrevVisisbilitySubject = new Subject();
        this.nextPrevVisisbilitySubject$ = this.nextPrevVisisbilitySubject.asObservable();
    }
}
StepStatusUpdateComponentLibraryService.ɵfac = function StepStatusUpdateComponentLibraryService_Factory(t) { return new (t || StepStatusUpdateComponentLibraryService)(); };
StepStatusUpdateComponentLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: StepStatusUpdateComponentLibraryService, factory: StepStatusUpdateComponentLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepStatusUpdateComponentLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function StepStatusUpdateComponentLibraryComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.updateStepStatus("SUBMIT"); });
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2, " Mark Submit ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵelement(5, "i", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", (ctx_r0.stepDetails == null ? null : ctx_r0.stepDetails.stepStatusDetails == null ? null : ctx_r0.stepDetails.stepStatusDetails.stepStatusCode) !== "INPROGRESS" || (ctx_r0.stepDetails == null ? null : ctx_r0.stepDetails.isReadOnly) === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pTooltip", ctx_r0.tootlTipTextMarkSubmit);
} }
const _c0 = function (a0) { return { hideView: a0 }; };
function StepStatusUpdateComponentLibraryComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.updateStepStatus("COMPLETE"); });
    i0.ɵɵelementStart(1, "span", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3, "Mark Complete");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r1.isViewMode || ctx_r1.beneQuestIsCaseRequest === "true"))("disabled", (ctx_r1.stepDetails == null ? null : ctx_r1.stepDetails.stepStatusDetails == null ? null : ctx_r1.stepDetails.stepStatusDetails.stepStatusCode) !== "INPROGRESS" || (ctx_r1.stepDetails == null ? null : ctx_r1.stepDetails.isReadOnly) === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pTooltip", ctx_r1.tootlTipTextMarkComplete);
} }
function StepStatusUpdateComponentLibraryComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 20);
} }
function StepStatusUpdateComponentLibraryComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.updateStepStatus("INPROGRESS"); });
    i0.ɵɵelementStart(1, "span", 17);
    i0.ɵɵelement(2, "img", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 18);
    i0.ɵɵtext(4, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r3.isViewMode || ctx_r3.beneQuestIsCaseRequest === "true"))("disabled", (ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.isReadOnly) === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pTooltip", ctx_r3.tootlTipTextEdit);
} }
function StepStatusUpdateComponentLibraryComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.updateStepStatus("INPROGRESS"); });
    i0.ɵɵelement(1, "i", 24);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r4.isViewMode || ctx_r4.beneQuestIsCaseRequest === "true"))("disabled", (ctx_r4.stepDetails == null ? null : ctx_r4.stepDetails.stepStatusDetails == null ? null : ctx_r4.stepDetails.stepStatusDetails.stepStatusCode) === "NEW" || (ctx_r4.stepDetails == null ? null : ctx_r4.stepDetails.stepStatusDetails == null ? null : ctx_r4.stepDetails.stepStatusDetails.stepStatusCode) === "INPROGRESS" || (ctx_r4.stepDetails == null ? null : ctx_r4.stepDetails.isReadOnly) === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pTooltip", ctx_r4.tootlTipTextEdit);
} }
function StepStatusUpdateComponentLibraryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25, 26);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_div_6_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r20); const _r18 = i0.ɵɵreference(1); i0.ɵɵnextContext(); const _r8 = i0.ɵɵreference(10); return _r8.toggle($event, _r18); });
    i0.ɵɵelement(2, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("yellow", (ctx_r5.stepDetails == null ? null : ctx_r5.stepDetails.notesAvailable) === true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r5.isViewMode || ctx_r5.beneQuestIsCaseRequest === "true"))("pTooltip", (ctx_r5.stepDetails == null ? null : ctx_r5.stepDetails.notes == null ? null : ctx_r5.stepDetails.notes.noteText) ? ctx_r5.stepDetails.notes.noteText : "Note");
} }
function StepStatusUpdateComponentLibraryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28, 26);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_div_7_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r23); const _r21 = i0.ɵɵreference(1); i0.ɵɵnextContext(); const _r8 = i0.ɵɵreference(10); return _r8.toggle($event, _r21); });
    i0.ɵɵelement(2, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("yellow", (ctx_r6.stepDetails == null ? null : ctx_r6.stepDetails.notesAvailable) === true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r6.isViewMode || ctx_r6.beneQuestIsCaseRequest === "true"))("pTooltip", (ctx_r6.stepDetails == null ? null : ctx_r6.stepDetails.notes == null ? null : ctx_r6.stepDetails.notes.noteText) ? ctx_r6.stepDetails.notes.noteText : "Note");
} }
function StepStatusUpdateComponentLibraryComponent_div_8_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_div_8_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.prevStep(); });
    i0.ɵɵelement(1, "span", 32);
    i0.ɵɵelementStart(2, "span", 33);
    i0.ɵɵtext(3, "Previous Step");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function StepStatusUpdateComponentLibraryComponent_div_8_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵlistener("click", function StepStatusUpdateComponentLibraryComponent_div_8_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.nextStep(); });
    i0.ɵɵelementStart(1, "span", 33);
    i0.ɵɵtext(2, "Next Step");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 35);
    i0.ɵɵelementEnd();
} }
function StepStatusUpdateComponentLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, StepStatusUpdateComponentLibraryComponent_div_8_button_1_Template, 4, 0, "button", 29);
    i0.ɵɵtemplate(2, StepStatusUpdateComponentLibraryComponent_div_8_button_2_Template, 4, 0, "button", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("step-navigation ml-4 ", ctx_r7.extraStyleClassForPrevNext, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showPreviousStepBtn);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showNextStepBtn);
} }
function StepStatusUpdateComponentLibraryComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "task-notes-lib", 36);
    i0.ɵɵlistener("noteAdded", function StepStatusUpdateComponentLibraryComponent_ng_template_11_Template_task_notes_lib_noteAdded_0_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.updateNoteAvailability($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("step", ctx_r9.stepDetails);
} }
class StepStatusUpdateComponentLibraryComponent {
    constructor(store, stepStatusUpdatePayloadCostruction, dialog, ngxService, stepUpdateService, referenceLibraryService) {
        this.store = store;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.dialog = dialog;
        this.ngxService = ngxService;
        this.stepUpdateService = stepUpdateService;
        this.referenceLibraryService = referenceLibraryService;
        this.onStatusToggle = new EventEmitter();
        this.resetForm = new EventEmitter();
        this.showPreviousStepBtn = false;
        this.showNextStepBtn = false;
        this.extraStyleClassForPrevNext = '';
        this.stepLayoutCodes = ['POSITION_DETAIL', 'BEN_POSITION_DETAIL', 'BEN_H1_B_POSITION_DETAIL', 'H1_B_POSITION_DETAIL', 'PAST_POSITION_DETAIL', 'BEN_PAST_POSITION_DETAIL', 'H1B_POSITION_DETAIL'];
        this.tootlTipTextMarkComplete = '';
        this.tootlTipTextEdit = '';
        this.tootlTipTextMarkSubmit = '';
    }
    get stepDetails() {
        return this._stepDetails;
    }
    set stepDetails(value) {
        this._stepDetails = value;
        if (this._stepDetails != null) {
            this.tootlTipTextMarkComplete = `To update the '${this.stepDetails.stepName}' step status to COMPLETE in Timeline, Please click on "Mark Complete" Button`;
            this.tootlTipTextEdit = `To update the '${this.stepDetails.stepName}' step status to IN-PROGRESS in Timeline, Please click on "Edit" Button`;
            this.tootlTipTextMarkSubmit = `To update the '${this.stepDetails.stepName}' step status to SUBMIT in Timeline, Please click on "Mark Submit" Button`;
        }
    }
    ngOnInit() {
        if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
            this.isSimplify = true;
        }
        else {
            this.isSimplify = false;
        }
        this.beneQuestIsCaseRequest = 'beneQuestIsCaseRequest' in sessionStorage ? sessionStorage.getItem('beneQuestIsCaseRequest') : 'false';
        this.userType = sessionStorage.getItem("userTypeRole");
        // this.tootlTipTextMarkComplete = `To update the '${this.stepDetails.stepName}' step status to COMPLETE in Timeline, Please click on "Mark Complete" Button`;
        // this.tootlTipTextEdit = `To update the '${this.stepDetails.stepName}' step status to IN-PROGRESS in Timeline, Please click on "Edit" Button`;
        // this.tootlTipTextMarkSubmit = `To update the '${this.stepDetails.stepName}' step status to SUBMIT in Timeline, Please click on "Mark Submit" Button`;
        this.stepUpdateService.nextPrevVisisbilitySubject$.pipe(take(1)).subscribe((data) => {
            if (['MARK_COMPLETE'].includes(this.type)) {
                this.showPreviousStepBtn = data === null || data === void 0 ? void 0 : data.showPrev;
                this.showNextStepBtn = data === null || data === void 0 ? void 0 : data.showNext;
            }
        });
    }
    get stepStatus() {
        return stepStatus;
    }
    updateStepStatus(status) {
        if (this.stepDetails['stepActionList'] && this.stepLayoutCodes.includes(this.stepDetails['stepActionList'][0]['layoutCode'])) {
            this.store.select(selectFormDirty).pipe(take(1)).subscribe(formState => {
                if (!formState.dirty) {
                    this.continueToStepUpdate(status);
                }
                else {
                    this.ngxService.stopAll();
                    return this.dialog.open(ConfirmationModalComponent, {
                        width: '400px',
                        data: {
                            update: {
                                title: 'Unsaved Changes!',
                                message: 'If you leave before saving, all changes made on the page will be lost. Do you wish to continue?'
                            },
                            buttons: ['No', 'Yes'],
                            disableClose: true
                        }
                    }).beforeClosed().pipe(take(1)).subscribe((confirmed) => {
                        if (confirmed)
                            this.continueToStepUpdate(status);
                    });
                }
            });
        }
        else {
            this.continueToStepUpdate(status);
        }
    }
    continueToStepUpdate(status) {
        var _a, _b;
        this.onStatusToggle.emit(status);
        if (status === 'COMPLETE' || status === 'SUBMIT') {
            this.resetForm.emit();
            this.store.dispatch(new MarkCleanFormAction({
                dirty: false
            }));
        }
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: (_a = this.stepDetails) === null || _a === void 0 ? void 0 : _a.taskId,
            visaType: this.visaType,
            stepId: (_b = this.stepDetails) === null || _b === void 0 ? void 0 : _b.id
        }));
    }
    updateNoteAvailability(e) {
        this.stepDetails['notesAvailable'] = (e === null || e === void 0 ? void 0 : e.notesAvailable) || false;
        this.stepDetails.notes.noteText = e.noteText || '';
    }
    prevStep() {
        let result = {
            currentStep: this.stepDetails,
            action: 'prev'
        };
        this.stepUpdateService.closeSubject.next(result);
    }
    nextStep() {
        let result = {
            currentStep: this.stepDetails,
            action: 'next'
        };
        this.stepUpdateService.closeSubject.next(result);
    }
    ngAfterViewInit() {
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
}
StepStatusUpdateComponentLibraryComponent.ɵfac = function StepStatusUpdateComponentLibraryComponent_Factory(t) { return new (t || StepStatusUpdateComponentLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i3.MatDialog), i0.ɵɵdirectiveInject(i4.NgxUiLoaderService), i0.ɵɵdirectiveInject(StepStatusUpdateComponentLibraryService), i0.ɵɵdirectiveInject(i6.ReferenceLibraryService)); };
StepStatusUpdateComponentLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: StepStatusUpdateComponentLibraryComponent, selectors: [["lib-step-status-update-component-library"]], inputs: { stepDetails: "stepDetails", type: "type", visaType: "visaType", isViewMode: "isViewMode", isCaseRequest: "isCaseRequest", showPreviousStepBtn: "showPreviousStepBtn", showNextStepBtn: "showNextStepBtn", extraStyleClassForPrevNext: "extraStyleClassForPrevNext" }, outputs: { onStatusToggle: "onStatusToggle", resetForm: "resetForm" }, decls: 12, vars: 10, consts: [["type", "button", "class", "im-btn im-btn-with-icon im-btn-outline-primary  d-flex align-items-center button_whitebg stepCompleted", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "im-btn im-btn-with-icon im-btn-outline-primary d-flex align-items-center button_whitebg stepCompleted", 3, "ngClass", "disabled", "click", 4, "ngIf"], [1, "stepCompleted"], ["src", "../../../../../assets/images/stepCompleteLabel.png", "alt", "Step Complete", 4, "ngIf"], ["type", "button", "class", "im-btn-with-icon im-btn-outline-primary  d-flex align-items-center button_whitebg edit", 3, "ngClass", "disabled", "click", 4, "ngIf"], ["class", "btn btn-xs btn-secondary customEdit", "type", "button", 3, "ngClass", "disabled", "click", 4, "ngIf"], ["class", "icon-background notes task-notes-btn", 3, "ngClass", "pTooltip", "yellow", "click", 4, "ngIf"], ["class", "icon-background-custom notes task-notes-btn", 3, "ngClass", "pTooltip", "yellow", "click", 4, "ngIf"], [3, "class", 4, "ngIf"], ["appendTo", "btnNote", 1, "notepanel", 3, "showCloseIcon", "dismissable"], ["notepanel", ""], ["pTemplate", ""], ["type", "button", 1, "im-btn", "im-btn-with-icon", "im-btn-outline-primary", "d-flex", "align-items-center", "button_whitebg", "stepCompleted", 3, "disabled", "click"], ["tooltipPosition", "bottom", 1, "mr-2", "d-flex", "align-items-center", "common-bene-class-for-translation", 3, "pTooltip"], [1, "vertical-line"], [1, "pi", "pi-exclamation-circle", "exclCircle"], ["type", "button", 1, "im-btn", "im-btn-with-icon", "im-btn-outline-primary", "d-flex", "align-items-center", "button_whitebg", "stepCompleted", 3, "ngClass", "disabled", "click"], ["tooltipPosition", "bottom", 1, "mr-2", "d-flex", "align-items-center", 3, "pTooltip"], [1, "common-bene-class-for-translation"], [1, "pi", "pi-exclamation-circle", "span-pi-exclamation-circle"], ["src", "../../../../../assets/images/stepCompleteLabel.png", "alt", "Step Complete"], ["type", "button", 1, "im-btn-with-icon", "im-btn-outline-primary", "d-flex", "align-items-center", "button_whitebg", "edit", 3, "ngClass", "disabled", "click"], ["src", "../../../../../assets/images/edit.png", "alt", "Edit"], ["type", "button", 1, "btn", "btn-xs", "btn-secondary", "customEdit", 3, "ngClass", "disabled", "click"], ["tooltipPosition", "bottom", 1, "fa", "fa-pencil", "ml-0", 3, "pTooltip"], [1, "icon-background", "notes", "task-notes-btn", 3, "ngClass", "pTooltip", "click"], ["btnNote", ""], [1, "icn-note"], [1, "icon-background-custom", "notes", "task-notes-btn", 3, "ngClass", "pTooltip", "click"], ["pButton", "", "class", "blue-btn mr-2 p-button p-component", "type", "button", 3, "click", 4, "ngIf"], ["pButton", "", "class", "blue-btn p-button p-component", "type", "button", 3, "click", 4, "ngIf"], ["pButton", "", "type", "button", 1, "blue-btn", "mr-2", "p-button", "p-component", 3, "click"], ["aria-hidden", "true", 1, "p-button-icon", "pi", "pi-chevron-left"], [1, "p-button-label", "common-bene-class-for-translation"], ["pButton", "", "type", "button", 1, "blue-btn", "p-button", "p-component", 3, "click"], ["aria-hidden", "true", 1, "p-button-icon", "p-button-icon-right", "pi", "pi-chevron-right"], [3, "step", "noteAdded"]], template: function StepStatusUpdateComponentLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, StepStatusUpdateComponentLibraryComponent_button_0_Template, 6, 2, "button", 0);
        i0.ɵɵtemplate(1, StepStatusUpdateComponentLibraryComponent_button_1_Template, 5, 5, "button", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, StepStatusUpdateComponentLibraryComponent_img_3_Template, 1, 0, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, StepStatusUpdateComponentLibraryComponent_button_4_Template, 5, 5, "button", 4);
        i0.ɵɵtemplate(5, StepStatusUpdateComponentLibraryComponent_button_5_Template, 4, 5, "button", 5);
        i0.ɵɵtemplate(6, StepStatusUpdateComponentLibraryComponent_div_6_Template, 3, 6, "div", 6);
        i0.ɵɵtemplate(7, StepStatusUpdateComponentLibraryComponent_div_7_Template, 3, 6, "div", 7);
        i0.ɵɵtemplate(8, StepStatusUpdateComponentLibraryComponent_div_8_Template, 3, 5, "div", 8);
        i0.ɵɵelementStart(9, "p-overlayPanel", 9, 10);
        i0.ɵɵtemplate(11, StepStatusUpdateComponentLibraryComponent_ng_template_11_Template, 1, 1, "ng-template", 11);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.type === "MARK_SUBMIT");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "MARK_COMPLETE" && (ctx.stepDetails == null ? null : ctx.stepDetails.stepStatusDetails == null ? null : ctx.stepDetails.stepStatusDetails.stepStatusCode) === "INPROGRESS");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.type === "MARK_COMPLETE" && (ctx.stepDetails == null ? null : ctx.stepDetails.stepStatusDetails == null ? null : ctx.stepDetails.stepStatusDetails.stepStatusCode) === "COMPLETE");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "EDIT" && !ctx.isSimplify && (ctx.stepDetails == null ? null : ctx.stepDetails.stepStatusDetails == null ? null : ctx.stepDetails.stepStatusDetails.stepStatusCode) === "COMPLETE");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "EDIT" && ctx.isSimplify);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "EDIT" && !ctx.isSimplify);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "EDIT" && ctx.isSimplify);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPreviousStepBtn || ctx.showNextStepBtn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("showCloseIcon", true)("dismissable", true);
    } }, directives: [i7.NgIf, i8.OverlayPanel, i9.PrimeTemplate, i10.Tooltip, i7.NgClass, i11.ButtonDirective, i12.TaskNotesLibComponent], styles: [".icon-background[_ngcontent-%COMP%]{height:30px;display:inline-block;border-radius:50%;width:26px;padding:4px;vertical-align:middle;background:#ededed;margin:0 10px;position:absolute;top:4px;right:0}.icon-background.notes[_ngcontent-%COMP%]{height:34px!important;margin:0 4px!important;cursor:pointer;border-radius:0}.icon-background.notes[_ngcontent-%COMP%]   .icn-note[_ngcontent-%COMP%]{background-image:url(../../../assets/images/Notes.svg)!important;background-repeat:no-repeat;position:absolute;height:22px;width:18px}.icon-background.notes.yellow[_ngcontent-%COMP%]{background:#febc54}.pnButton[_ngcontent-%COMP%]{width:10rem}.icon-background-custom[_ngcontent-%COMP%]{display:inline-block;width:30px;padding:4px;vertical-align:middle;right:0}.icon-background-custom.notes[_ngcontent-%COMP%]{height:34px!important;margin:0 4px!important;cursor:pointer;border-radius:0}.icon-background-custom.notes[_ngcontent-%COMP%]   .icn-note[_ngcontent-%COMP%]{background-image:url(../../../assets/images/Notes.svg)!important;background-repeat:no-repeat;position:absolute;height:22px;width:18px}.icon-background-custom.notes.yellow[_ngcontent-%COMP%]{background:#febc54}.notepanel   [_nghost-%COMP%]     .p-overlaypanel{width:500px!important;background:#fff3df!important;top:auto!important;right:-20px}.notepanel   [_nghost-%COMP%]     .p-overlaypanel:before{margin-left:6px!important;border-bottom-color:transparent!important}.notepanel   [_nghost-%COMP%]     .p-overlaypanel:after{border:0!important;border-color:transparent!important}.notepanel   [_nghost-%COMP%]     .p-overlaypanel .p-overlaypanel-close{background:#febc54!important;color:#777!important}.hideView[_ngcontent-%COMP%]{visibility:hidden}.showView[_ngcontent-%COMP%]{visibility:visible}.customEdit[_ngcontent-%COMP%]{border-radius:2px!important;padding:0 10px!important;background-color:#fff!important;border-color:#059ad2!important;color:#059ad2!important}.step-navigation[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepStatusUpdateComponentLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-step-status-update-component-library',
                templateUrl: './step-status-update-component-library.component.html',
                styleUrls: ['./step-status-update-component-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.StepStatusUpdatePayloadService }, { type: i3.MatDialog }, { type: i4.NgxUiLoaderService }, { type: StepStatusUpdateComponentLibraryService }, { type: i6.ReferenceLibraryService }]; }, { stepDetails: [{
            type: Input
        }], type: [{
            type: Input
        }], visaType: [{
            type: Input
        }], onStatusToggle: [{
            type: Output
        }], resetForm: [{
            type: Output
        }], isViewMode: [{
            type: Input
        }], isCaseRequest: [{
            type: Input
        }], showPreviousStepBtn: [{
            type: Input
        }], showNextStepBtn: [{
            type: Input
        }], extraStyleClassForPrevNext: [{
            type: Input
        }] }); })();

class StepStatusUpdateComponentLibraryModule {
}
StepStatusUpdateComponentLibraryModule.ɵfac = function StepStatusUpdateComponentLibraryModule_Factory(t) { return new (t || StepStatusUpdateComponentLibraryModule)(); };
StepStatusUpdateComponentLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: StepStatusUpdateComponentLibraryModule });
StepStatusUpdateComponentLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            TaskNotesLibModule,
            AssigningTaskLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(StepStatusUpdateComponentLibraryModule, { declarations: [StepStatusUpdateComponentLibraryComponent], imports: [PrimengLibraryModule,
        TaskNotesLibModule,
        AssigningTaskLibraryModule], exports: [StepStatusUpdateComponentLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepStatusUpdateComponentLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [StepStatusUpdateComponentLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    TaskNotesLibModule,
                    AssigningTaskLibraryModule,
                ],
                exports: [StepStatusUpdateComponentLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of step-status-update-component-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { StepStatusUpdateComponentLibraryComponent, StepStatusUpdateComponentLibraryModule, StepStatusUpdateComponentLibraryService };
//# sourceMappingURL=step-status-update-component-library.js.map
